/**
 * Engine row id for the summary band. A fixed token, not `getRowId`: the band never joins the
 * row model, so this id is only ever the namespace for its own cells' React keys — it cannot
 * collide with a data row's id, and calling the consumer's `getRowId` would mean inventing a
 * data position for a record that has none.
 *
 * PUBLIC because it is the band's discriminator: a `renderCell`/`renderRow` seam or a test that
 * must tell the band apart from a data row compares `row.id` against THIS constant, instead of
 * each consumer planting a sentinel inside its own aggregate record and every cell renderer
 * learning to recognise it. A column that merely formats its total differently wants
 * `meta.summaryCell`, not the discriminator.
 *
 * A `.constants.ts` sibling (like `column-header-menu.constants.ts`) so the component file keeps
 * exporting only components — the fast-refresh purity `only-export-components` asks for.
 */
export const DATA_TABLE_SUMMARY_ROW_ID = 'summary'
